import { SCHEDULER_MAP_CLINICIAN_SELECT } from '../../constants/types';

export function selectClinicianOnMap(clinicianId) {
  return {
    type: SCHEDULER_MAP_CLINICIAN_SELECT,
    clinicianId,
  };
}
